import Roles from "../../configs/Roles";

const titles = {
    Billing: 'Billing',
    InvoiceDetails: 'InvoiceDetails'
};

export const Billing = [
    {
        icon: 'InvoicesNavSvgIcon',
        component: 'Billing',
        path: '/billing',
        title: titles.Billing,
        key: 'billing',
        menu: 'Billing',
        parent: true,
        // permission:[Roles.RESELLER]
    },
    {
        component: 'InvoiceDetails',
        path: '/billing/invoice/:invoiceId',
        title: titles.InvoiceDetails,
        key: 'invoice-details',
        menu: false,
        parent: false,
    }
];
